export default __webpack_public_path__ + "static/media/case2 (3).af297207.jpg";